import FilterCardMultiSelect from '../../generic/Filter/FilterCardMultiSelect';
import FilterPanel from '../../generic/Filter/FilterPanel';
import type { SelectOption } from '../../../types';

type Props = {
  licenses: string[];
  selectedOptions: string[];
  onSet: (licenses: string[]) => void;
};

const LicenseIDFilter = ({ licenses, selectedOptions, onSet }: Props) => {
  const options: Array<SelectOption<string>> = licenses.map((license) => {
    return { value: license, label: license };
  });

  const values: Array<SelectOption<string>> = selectedOptions.map((license) => {
    return { value: license, label: license };
  });

  return (
    <FilterPanel>
      <FilterCardMultiSelect
        label="Licenses"
        placeholder="Select one or more..."
        options={options}
        values={values}
        onChange={(selectedValues) => {
          if (selectedValues.length) {
            onSet(selectedValues.map(o => o.value as string));
          } else {
            onSet([]);
          }
        }}
        testId="issues-vuln-ignore-reason"
      />
    </FilterPanel>
  );
};

export default LicenseIDFilter;
